// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import tableState from './initialState'
import datatable from './datatable'
import filtersState from './filters/initialState'

// Assets Operator
import {
  initialState as operatorState,
  reducers as operatorReducers,
} from 'fc-operator-sampling-jobs'

import tableOperator from './tableOperator'

import {
  initialState as importJobsToolOperatorState,
  reducers as importJobsToolOperatorReducers,
} from 'hfty-operator-import-jobs-tool'

import {
  initialState as importJobsPopupOperatorState,
  reducers as importJobsPopupOperatorReducers,
} from 'hfty-operator-import-jobs-popup'

import {
  initialState as reopenJobOperatorState,
  reducers as reopenJobOperatorReducers,
} from 'hfty-operator-reopen-job'

// Filters reducer
import filtersReducers from './filters/filterReducers'

// Sampling Points reducer
import {
  initialState as samplingPointState,
  reducers as samplingPointReducers,
} from 'hfty-operator-sampling-point'

// Exports
export default createReducer({
  ...tableState,
  ...operatorState,
  ...filtersState,
  tableOperation: null,
  ...importJobsToolOperatorState,
  ...importJobsPopupOperatorState,
  ...reopenJobOperatorState,
  ...samplingPointState,
}, {
  ...datatable.reducers,
  ...operatorReducers,
  ...tableOperator.reducers,
  ...filtersReducers,
  ...importJobsToolOperatorReducers,
  ...importJobsPopupOperatorReducers,
  ...reopenJobOperatorReducers,
  ...samplingPointReducers,
})
